export const COMPONENT_NAME = "application-confirm";
